import { ColumnDefinition, ColumnDefinitions } from '../../shared/types/common';
import { TaxAccountingType } from './types';
import { SheetExportTypes } from '@common/xlsxExport/xlsxExport.constants';
import { periodColumnDefinition } from '../../shared/columnDefinitions';
import xlsxExport from '../../shared/xlsxExport/xlsxExport';

type downloadTaxAccountingProps = {
  entities: TaxAccountingType[],
  periodName: string,
  environmentSuffix: string
  shouldDisplayZero: boolean,
  hideDecimals: boolean,
  negativeMinus: boolean,
  columnDefs: ColumnDefinitions,
  additionalData: any
}

export default ({
  entities,
  periodName,
  environmentSuffix,
  shouldDisplayZero,
  hideDecimals,
  negativeMinus,
  columnDefs,
}: downloadTaxAccountingProps) => {
  const taxAccountingWithPeriods = entities.map(legalEntity => ({
    periodName,
    ...legalEntity,
  }));

  const sheetData = [
    {
      name: 'Tax Accounting Data',
      type: SheetExportTypes.GRID,
      descriptionColumnIndex: -1,
      columnDefinitions: [
        {
          ...periodColumnDefinition,
          rowGroup: true,
          hide: true,
          enableGroup: true,
          minWidth: 200,
        } as ColumnDefinition,
        ...columnDefs,
      ],
      data: taxAccountingWithPeriods,
      options: {
        hideDecimals,
        negativeMinus,
        shouldDisplayZero,
      },
    },
    {
      name: 'Metadata',
      type: SheetExportTypes.CUSTOM,
      data: [],
      options: {
        addTimestamp: true,
      },
    },
  ];

  xlsxExport({
    sheetData,
    metadata: {
      fileName: `TLS_Tax_Accounting_${periodName}${environmentSuffix}`,
      disableHeaderRendering: true,
    },
  });
};
